import React from 'react'
import moment from 'moment'

// graphql
import { useQuery } from '@apollo/client'
import { GET_JOB_DAY_BY_ID_FOR_SPLIT } from '../../../../../graphql/jobDay/jobDay.queries'

// components
import FormDataPoint from '../../../../../components/forms/FormDataPoint/FormDataPoint.component'

export default function JobDayInfo({ jobDayId }) {

    let jobDay = { job: {} }

    const { data } = useQuery(GET_JOB_DAY_BY_ID_FOR_SPLIT, { 
        variables: { id: parseInt(jobDayId, 10) }
    })

    if (data && data.jobDay) {
        jobDay = { ...data.jobDay }
    }

    return (
        <div>
            <FormDataPoint label='Job' value={[jobDay.job.name]} />
            <FormDataPoint 
                label='Address' 
                value={jobDay.job.street1 ? [
                    `${jobDay.job.street1}`, 
                    `${jobDay.job.city}, ${jobDay.job.state} ${jobDay.job.zipcode}`
                ] : null} 
            />
            <FormDataPoint 
                label='Start Time' 
                value={[moment(`${jobDay.date} ${jobDay.startTime}`).format("hh:mm A")]} 
            />
        </div>
    )
}
